import { render } from "./UrneView.vue?vue&type=template&id=57fdba1e"
import script from "./UrneView.vue?vue&type=script&lang=js"
export * from "./UrneView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__